<template>
    <b-modal id="brand_delete" ref="brand_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.brand.data.attributes.name + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('brand_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteBrand">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "ProductBrandDeleteModal",

        components: {
            StateButton
        },

        props: [
            'brand'
        ],

        methods: {
            hideModal(refname) {
                this.$refs[refname].hide();
            },

            deleteBrand() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteBrand', this.brand)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-brand');

                                this.$notify('error filled', 'Success!', 'Deleted the brand!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('brand_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
        }
    }
</script>

<style scoped>

</style>
